import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { isSuperAdminRole } from "../../api/admin";
import SuperAdminEventManagement from "./SuperAdminEventManagement";

export default function UserPageAdministration() {
  const { currentUser } = useContext(GlobalContext);

  if (!currentUser) {
    return <p>Please sign in.</p>;
  }

  if (!isSuperAdminRole(currentUser.role)) {
    return <Navigate to="/user/events" replace />;
  }

  return (
    <div>
      <h2 className="font-bold text-lg text-slate-900 mb-1">Administration</h2>
      <p className="text-sm text-slate-600 mb-8">
        Approve access requests and manage event administrators.
      </p>
      <SuperAdminEventManagement />
    </div>
  );
}
